import { Link } from "react-router-dom";

const galleryItems = [
  {
    city: "Manhattan, New York",
    description: "A tapestry of urban geometry and concrete dreams, woven in time.",
    price: "$55",
    styles: "8 styles available",
    image: "/images/gallery-nyc.jpeg",
  },
  {
    city: "Paris, France",
    description: "Whispers of romance and history along the banks of the Seine.",
    price: "$55",
    styles: "8 styles available",
    image: "/images/gallery-paris.jpeg",
  },
  {
    city: "San Francisco, CA",
    description: "A city of hills and horizons, where golden light touches the sea.",
    price: "$55",
    styles: "8 styles available",
    image: "/images/gallery-sf.jpeg",
  },
];

const GalleryCurated = () => {
  return (
    <section className="py-24 px-6" style={{ backgroundColor: "var(--brand-bg)" }}>
      <div className="max-w-[80rem] mx-auto">
        <div className="text-center mb-16">
          <p className="text-sm tracking-[0.2em] uppercase mb-3" style={{ color: "var(--sage-400)", fontFamily: "var(--font-body)" }}>
            Curated Collections
          </p>
          <h2 className="mb-4" style={{ fontSize: "clamp(2.25rem, 4vw, 3rem)", fontFamily: "var(--font-heading)", color: "var(--brand-text)" }}>
            Collectible Art
          </h2>
          <p className="max-w-lg mx-auto" style={{ color: "var(--brand-muted)", fontWeight: 300, fontFamily: "var(--font-body)" }}>
            Each city tells a unique story through its streets, waterways, and landmarks. Explore our curated collection or design your own.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {galleryItems.map((item) => (
            <Link to="/studio" key={item.city} className="group cursor-pointer">
              <div className="rounded-xl overflow-hidden border" style={{ backgroundColor: "var(--brand-card)", borderColor: "var(--brand-border)", boxShadow: "0 1px 2px rgba(0,0,0,0.05)" }}>
                <div className="aspect-[4/3] overflow-hidden relative bg-gray-50">
                  <img src={item.image} alt={item.city} loading="lazy" className="w-full h-full object-cover" />
                  <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300" style={{ backgroundColor: "rgba(44, 58, 51, 0.6)" }}>
                    <span className="rounded-full px-6 py-2.5 text-sm font-medium text-white" style={{ backgroundColor: "var(--sage-400)" }}>
                      Design This Map
                    </span>
                  </div>
                </div>
                <div className="p-5">
                  <h3 className="text-lg mb-1" style={{ fontFamily: "var(--font-heading)", color: "var(--brand-text)" }}>
                    {item.city}
                  </h3>
                  <p className="text-sm mb-3" style={{ color: "var(--brand-muted)", fontWeight: 300, fontFamily: "var(--font-body)" }}>
                    {item.description}
                  </p>
                  <div className="flex items-center justify-between">
                    <span className="text-sm font-medium" style={{ color: "var(--sage-400)", fontFamily: "var(--font-body)" }}>
                      From {item.price}
                    </span>
                    <span className="text-xs" style={{ color: "var(--brand-light)", fontFamily: "var(--font-body)" }}>
                      {item.styles}
                    </span>
                  </div>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default GalleryCurated;
